import { getCookie } from 'wtb-utils';

const getDeviceLocale = (availableLanguages) => {
  const savedLocale = getCookie('locale')?.value;
  const systemLocale = window.navigator.language?.split('-')[0];

  if (availableLanguages?.includes(savedLocale)) {
    return savedLocale;
  } else if (availableLanguages?.includes(systemLocale)) {
    return systemLocale;
  } else {
    return undefined;
  }
};

export default getDeviceLocale;
